export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5177.f178df88.jpg";